import { render } from "./MainInfoContent.vue?vue&type=template&id=3f7fb215&scoped=true"
import script from "./MainInfoContent.vue?vue&type=script&lang=js"
export * from "./MainInfoContent.vue?vue&type=script&lang=js"

import "./MainInfoContent.vue?vue&type=style&index=0&id=3f7fb215&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7fb215"]])

export default __exports__